import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import auth from "../stores/auth";
// import lang from '../stores/lang'
import  error from "../stores/forbiden.js"
const store = createStore({
    plugins: [createPersistedState()],
    modules: {
        auth,
        error
    },
});

export default store;
